import { TwilioStatusCode } from '@navio/nsdk';
import { NoddiIconName } from 'noddi-ui-common';

export const SMS_STATUS_ICON: Record<TwilioStatusCode, NoddiIconName> = {
  [TwilioStatusCode.ACCEPTED]: 'ClipboardList',
  [TwilioStatusCode.CANCELED]: 'CalendarX',
  [TwilioStatusCode.DELIVERED]: 'PackageCheck',
  [TwilioStatusCode.FAILED]: 'TriangleAlert',
  [TwilioStatusCode.QUEUED]: 'List',
  [TwilioStatusCode.RECEIVED]: 'Download',
  [TwilioStatusCode.RECEIVING]: 'Loader2',
  [TwilioStatusCode.SCHEDULED]: 'CalendarClock',
  [TwilioStatusCode.SENDING]: 'Play',
  [TwilioStatusCode.SENT]: 'Mail',
  [TwilioStatusCode.UNDELIVERED]: 'PackageMinus'
};
